export const defaultSearchFilter = (): SearchFilter => {
  return {
    page: 1,
    limit: 50,
    filter: [],
    orderBy: [],
  };
};
